import cx from 'classnames';
import Image from 'next/image';

import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../design-system/components/form/button/Button';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { AgencyHighlightBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';
import { AdditionalData } from '../../PageView';
import { AgencyHighlightCarousel } from '../Nested/AgencyHighlightCarousel';

import style from './AgencyHighlightBlockSlice.module.css';

export type AgencyHighlightBlockSliceProps = AgencyHighlightBlockSliceType;

export function AgencyHighlightBlockSlice({
    title,
    text,
    ctaLabel,
    ctaLink,
    target,
    agenciesData,
    picture,
    sliceIndex,
}: AgencyHighlightBlockSliceProps & {
    agenciesData: AdditionalData['agencies'];
    sliceIndex?: number;
}) {
    const hasPicture = Boolean(picture?.url);
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div className={cx(style.wrapper, { [style.withPicture]: hasPicture })}>
            {picture?.url ? (
                <Image
                    className={style.picture}
                    alt={picture.alt}
                    src={picture.url}
                    unoptimized
                    fill
                    priority
                />
            ) : null}
            <div className={style.contentWrapper}>
                <div className="layout-with-centered-content">
                    <div className="main-container">
                        <div className={style.content}>
                            {title ? (
                                <Typography as="h2" scale="secondary-m-bold">
                                    {title}
                                </Typography>
                            ) : null}
                            <EvaneosPrismicRichText field={text} />

                            {ctaLabel && ctaLink?.url ? (
                                <Button
                                    priority="primary"
                                    href={ctaLink?.url}
                                    target={target || undefined}
                                    onClick={() => {
                                        trackEvent((ampli, defaultProperties) => {
                                            ampli.agentsHighlightBlockClicked({
                                                ...defaultProperties,
                                                block_index: sliceIndex ? sliceIndex + 1 : 0,
                                                block_title: title ?? undefined,
                                            });
                                        });
                                    }}
                                >
                                    {ctaLabel}
                                </Button>
                            ) : null}
                        </div>
                    </div>
                </div>
                {agenciesData ? (
                    <div className="col-12">
                        <AgencyHighlightCarousel
                            agencies={agenciesData}
                            lightText={hasPicture}
                            title={title}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}
